const testimonials = [
  {
    id: 1,
    imageUrl: "https://images.unsplash.com/photo-1713256683892-5bab22f76be0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c2hvcHBpbmclMjBnaXJsfGVufDB8fDB8fHww",
    name: "Ananya Reddy",
    title: "Absolutely Stunning ..",
    subName: "Women’s Fashion Buyer",
    designation: "Fashion Enthusiast",
    rating: 5,
    desc: "The dresses fit perfectly and the fabric quality feels premium. I received so many compliments at a party after wearing their collection. favorite fashion store now!"
  },

  {
    id: 2,
    imageUrl: "https://media.istockphoto.com/id/1293366109/photo/this-one-match-perfect-with-me.webp?a=1&b=1&s=612x612&w=0&k=20&c=e0bOeR004rMmcAvXUYAIiJZJ01pgAFX7ThFqfzyvMac=",
    name: "Rahul Sharma",
    title: "Perfect Men's Collection !",
    subName: "Verified Customer",
    designation: "Corporate Professional",
    rating: 5,
    desc: "Their men's shirts and jackets are super stylish and comfortable. The fitting is excellent and delivery was very fast. Highly recommended for trendy outfits."
  },

  {
    id: 3,
    imageUrl: "https://images.unsplash.com/photo-1713693212309-acdbf3a3feb4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c2hvcHBpbmclMjBnaXJsfGVufDB8fDB8fHww",
    name: "Sneha Kapoor",
    title: "Luxury Bags at Best Price....",
    subName: "Loyal Customer",
    designation: "Content Creator",
    rating: 4.5,
    desc: "I purchased a handbag recently and it looks so elegant. The quality is amazing and it matches perfectly with every outfit. Totally worth it with Modern styles!"
  },

  {
    id: 4,
    imageUrl: "https://plus.unsplash.com/premium_photo-1661281362580-95188f976fa1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8c2hvcHBpbmclMjBtZW58ZW58MHx8MHx8fDA%3D",
    name: "Arjun & Meera",
    title: "Best Couple Fashion Store!!!",
    subName: "Happy Shoppers",
    designation: "Fashion Lovers",
    rating: 5,
    desc: "We ordered matching outfits for a vacation and absolutely loved the collection. Modern styles, affordable pricing, and great customer support."
  },

  {
    id: 5,
    imageUrl: "https://media.istockphoto.com/id/852209020/photo/happy-father-and-son-at-the-shopping-center.webp?a=1&b=1&s=612x612&w=0&k=20&c=APbdvW9hvMxO8CAo5z4mPlNeWab0xyXnA3qjqHGi88U=",
    name: "Vikram Patel",
    title: "Amazing Shoes Collection..",
    subName: "Premium Member",
    designation: "Sneaker Collector",
    rating: 5,
    desc: "The sneakers are stylish, lightweight, and extremely comfortable. Packaging and delivery experience were also excellent. Will shop again for sure!"
  }
];

export { testimonials };